






























import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'RgsListItem',
  props: {
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    imageMobile: {
      type: String,
      default: '',
    },
    imageDesktop: {
      type: String,
      default: '',
    },
    svgIcon: {
      type: String,
      default: '',
    },
  },
  setup() {},
})
